import type { WidgetDataContract } from "@nexus/widget-sdk";

/**
 * `protection-overview-event-social` v1 — social-media chatter observed
 * around one protected event's piracy activity, grouped by platform.
 */
export const SOCIAL_MEDIA_POSTS_CONTRACT: WidgetDataContract = {
  name: "protection-overview-event-social",
  version: 1,
};

export type SocialMediaPlatformId = "x" | "reddit" | "telegram" | "facebook";

export interface SocialMediaMessage {
  author: string;
  handle: string;
  text: string;
  at: string;
}

export interface SocialMediaPlatform {
  platform: SocialMediaPlatformId;
  label: string;
  messageCount: number;
  messages: SocialMediaMessage[];
  /** Image reference of the network's logo (see `WidgetAssetsContext`). */
  logo?: string | null;
}

export interface SocialMediaPostsData {
  platforms: SocialMediaPlatform[];
}
